import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { INotificationRef } from '../../notification/notification-ref.interface';
import { Snackbar } from '../models';

export class SnackbarRef implements INotificationRef {
  private readonly _afterClosedSubject: Subject<unknown> = new Subject<unknown>();

  constructor(
    public readonly snackbar: Snackbar,
    private readonly _visibility$: BehaviorSubject<boolean>,
  ) { }

  public close(result?: string, callback?: (...args: any[]) => void): void {
    this._visibility$.next(false);

    this._afterClosedSubject.next(result);
    this._afterClosedSubject.complete();

    callback?.(result);
  }

  public afterClosed(): Observable<any> {
    return this._afterClosedSubject.asObservable();
  }
}
